<template>
  <div class="home">
    <div class="x" @click="gos">x</div>
    <div class="p1">
        货 空 间 双 十 一 年 度 钜 惠
    </div>
    <div class="p1 p2">
        活 动 距 离
    </div>
    <dao :deadline="'2025-09-30 18:00:00'"></dao>
    <div class="but">
        <van-button
          type="primary"
          size="large"
          @click="ok"
          round
          color="#222"
        >进入会场</van-button>
      </div>
  </div>
</template>
<script>
import Dao from './dao1.vue'
import Vue from 'vue'
import { Swipe, SwipeItem, Lazyload, NoticeBar, Grid, GridItem, Popup, Button, Toast } from 'vant'

Vue.use(Swipe)
  .use(SwipeItem)
  .use(Lazyload, { lazyComponent: true })
  .use(NoticeBar)
  .use(Grid)
  .use(GridItem).use(Popup).use(Button)
export default {
  created () {
    // 1731254400000
      sessionStorage.setItem("ks", '1')
        if(Date.parse(new Date())-1759226400000>=0){
        this.$router.push('ss')
    }else{

    }
    //   if(Date.parse(new Date())-1668062190000>=0){
    //     this.$router.push('ss')
    // }
    },
    data(){
        return{
            time:0
        }
    },
  methods: {
    go(){
      this.$router.push('/')
    },
    gos(){
      this.$router.push('/')

    },
    ok(){
 if(Date.parse(new Date())-1759226400000>=0){
        this.$router.push('ss')
    }else{
Toast('还没到时间哦~')
    }
    }
  },
  components: {
    Dao
  }
}
</script>

<style lang="less" scoped>
.home {
  // height: 5rem;
  height: 100%;
  width: 100%;
  background-color: #1b1b1b;
  padding-top: 6.2rem;
  text-align: center;
    background: url(../../assets/s11/dd.jpg) no-repeat center;
   background-size: 100% 100%;
  .x{
    width: 3rem;
    height: 2rem;
    // background-color: #f99;
    font-size: 1rem;
    color: #fff;
    position: fixed;
    top: 0;
    right: 0;
    padding-left: 1rem;
  }
  .p1{
    word-spacing: 0.05rem;
    font-size: 0.4rem;
  color: rgb(240, 246, 185);

  }
  .p2{
    word-spacing: 0.1rem;
font-size: 0.45rem;
padding-top: 0.5rem;
padding-bottom: 0.8rem;
  }
  .but{
    padding-top: 5rem;
    width: 80%;
    margin: 0 auto;
  }
  // background-color: rgb(228, 222, 222);
}
</style>
